import { Type } from 'class-transformer';
import { ProductComponent, ProductComponents } from './component';

export type Products = Product[];

export class Product {
  product_id: number;

  product_name: string;
  product_description: string;

  is_active: number // 0 = false, 1 = true

  quantity: number = 0;
  amount: number = 0;
  
  created_at: Date;
  updated_at: Date;

  product_components: string[] = [];

  components: ProductComponents = [];




  components_list: any[] = [];
  description: string;




  constructor(init?: Partial<Product>) {
    Object.assign(this, init);
  }

  public static OrderBy(products: Products, property: keyof Product): Products {
    return products.sort((a, b) => {
      if (a[property] < b[property]) return -1;
      if (a[property] > b[property]) return 1;
      return 0;
    })
  }
}